import React from "react";

import { IconName } from "../types";
import Icon from "./Icon";

const IconButton = (props: {
  icon: IconName;
  title: string;
  onClick?: () => void;
  size?: "large" | "small";
  active?: boolean;
  highlightStyle: "underline" | "tick";
}) => {
  return (
    <div
      role={"button"}
      className={`icon-button btn btn-secondary icon-button-${
        props.highlightStyle
      } ${props.size ? props.size : "small"} ${props.active ? "active" : ""}`}
      onClick={() => props.onClick && props.onClick()}
    >
      <Icon className={"left-icon"} name={props.icon} />
      <span className={"icon-button-title copy"}>{props.title}</span>
      {props.highlightStyle === "tick" && (
        <Icon className={"right-icon"} name={IconName.CHECK_MARK_CIRCLE} />
      )}
    </div>
  );
};

export default IconButton;
